exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-brand[data-v-2dd93324]{padding-top:.75rem;padding-bottom:.75rem;background-color:rgba(0,0,0,.25);-webkit-box-shadow:inset -1px 0 0 rgba(0,0,0,.25);box-shadow:inset -1px 0 0 rgba(0,0,0,.25);font-size:1.53125rem;font-weight:700}.navbar-brand a[data-v-2dd93324]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2dd93324","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Navbar.vue
// module id = DO5I
// module chunks = 1